import { gql } from "@/services/httpAdapter";

// Common fragments
import { AddedCompensationFragment, CompensationFragment, ReviewFragment } from "@/Washouts/api/common/fragments";

export function getOnNewServiceDepartmentalWashoutAvailable() {
	return gql`
		subscription onNewServiceDepartmentalWashoutAvailable($commissionCycleId: String, $payPeriodId: String, $userId: String) {
			onNewServiceDepartmentalWashoutAvailable(commissionCycleId: $commissionCycleId, payPeriodId: $payPeriodId, userId: $userId) {
				_id
				userId
				commissionCycleId
				payPeriodId
			}
		}
	`;
}

export function getOnUpdateServiceDepartmentalWashout() {
	return gql`
		subscription onUpdateServiceDepartmentalWashout(
			$commissionCycleId: String
			$payPeriodId: String
			$userId: String
			$position: String
		) {
			onUpdateServiceDepartmentalWashout(
				commissionCycleId: $commissionCycleId
				payPeriodId: $payPeriodId
				userId: $userId
				position: $position
			) {
				_id
				commissionCycleId
				payPeriodId
				userId
				review {
					...Review
				}
				addedCompensations {
					...AddedCompensation
				}
				summary {
					...Compensation
				}
			}
		}
		${AddedCompensationFragment}
		${CompensationFragment}
		${ReviewFragment}
	`;
}

export function getOnUpdateServiceDepartmentalWashoutStatus() {
	return gql`
		subscription onUpdateServiceDepartmentalWashoutStatus(
			$commissionCycleId: String
			$payPeriodId: String
			$userId: String
			$position: String
		) {
			onUpdateServiceDepartmentalWashoutStatus(
				commissionCycleId: $commissionCycleId
				payPeriodId: $payPeriodId
				userId: $userId
				position: $position
			) {
				_id
				commissionCycleId
				payPeriodId
				userId
				position
				status
				employee {
					position
				}
				review {
					...Review
				}
			}
		}
		${ReviewFragment}
	`;
}
